package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SubscriptionPlanRepository
import com.clany.backoffice.model.SubscriptionPlanResponse
import dev.zacsweers.metro.Inject

class GetSubscriptionPlansUseCase @Inject constructor(
    private val repository: SubscriptionPlanRepository
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
        query: String? = null
    ): Result<List<SubscriptionPlanResponse>> = repository.getSubscriptionPlans(page, pageSize, query)
}
